
<template>
  <div id="app">


      <router-view/>

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "~bulma";

  .center{
    display:flex;
    justify-content: center;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue